import { render } from "./BaseViewContainer.vue?vue&type=template&id=21baaa64&scoped=true"
import script from "./BaseViewContainer.vue?vue&type=script&lang=js"
export * from "./BaseViewContainer.vue?vue&type=script&lang=js"

import "./BaseViewContainer.vue?vue&type=style&index=0&id=21baaa64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21baaa64"]])

export default __exports__